import { createFileRoute } from '@tanstack/react-router'
import ReportTemplatesWrapper from '../../../containers/report-templates'
import RequirePermission from '../../../containers/authentication/components/require-permission'
import { useOrganizationalAccess } from '../../../hooks/use-organizational-access'
import { reportsSchema } from './search-schemas'

export const Route = createFileRoute('/_authenticated/reportTemplates/')({
  validateSearch: reportsSchema,
  component: ReportTemplatesRoute
})

function ReportTemplatesRoute() {
  const { isResolved, canSeeReportTemplates } = useOrganizationalAccess()

  return (
    <RequirePermission allowed={canSeeReportTemplates} isResolved={isResolved}>
      <ReportTemplatesWrapper />
    </RequirePermission>
  )
}
